export default __webpack_public_path__ + "static/02_discovery-4ecfe0a68a0085e99e40acb55e1ba336.webm";